
<div class="row p-2 my-2" style="display: flex;justify-content: space-between;">
<div *ngIf="showName" class="mat-body-1 displayFlex" [ngClass]="{'col-md-7':!IsConsentScreen,'col-md-8':IsConsentScreen}">
      <span *ngIf="!IsConsentScreen" [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span *ngIf="IsConsentScreen" [innerHTML]="question.consentQuestionLabel || question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
</div>
  <div [ngClass]="{'col-md-4': showName }">
    <div *ngIf="question.inputType === 'txb'">    
      <input class="mat-body-1 txt-style cursor blue-border" [ngClass]="{'w-87': !showName,'w-60': showName}"
       [disabled]="IsReadOnly || question.isReadOnly" [(ngModel)]="question.responseText" type="text" 
      [minLength]="minLength" [maxLength]="maxLength" 
      placeholder="Enter Response Here"
      (blur)="onBlur($event)" (input)="onSelect($event)" (focus)="onFocus($event)"
      [required]="isConditionIsTrue" [ariaLabel]="question.questionText" />
      <br />
      <div *ngIf="errormgvisible">
        <div class="mat-body-1 errormsg" *ngFor="let error of errorMessages" style="margin-left:10px">{{error}}</div>
      </div>

    </div>
    <div *ngIf="question.inputType === 'txa'">      
      <textarea class="mat-body-1 txt-style cursor txtarearesize" [ngClass]="{'w-87': !showName,'w-60': showName}" [disabled]="IsReadOnly" [(ngModel)]="question.responseText" placeholder="Enter Response Here"          
         [minLength]="minLength" [maxLength]="maxLength" rows="5" 
         (blur)="onBlur($event)" (input)="onSelect($event)" (focus)="onFocus($event)"
         [required]="isConditionIsTrue" [ariaLabel]="question.questionText" (keydown.enter)="$event.stopPropagation()">
      </textarea><br />
      <div *ngIf="errormgvisible">
        <div class="mat-body-1 errormsg" *ngFor="let error of errorMessages" style="margin-left:10px">{{error}}</div>
      </div>
    </div>
  </div>
</div>






